import { auth } from '@rhitics/core'
import { AxiosError } from 'axios'
import Vue, { VNode } from 'vue'
import { validateCompanyEmail } from '@rhitics/rhitics/helpers'

type VForm = Vue & {
  reset: () => void
  validate: () => boolean
}

export default Vue.extend({
  name: 'ResendEmail',

  data() {
    return {
      dialog: false,
      sended: false,
      error: '',
      email: '',
      emailValid: false,
      processing: false,
      rules: {
        required: (v: string) => !!v || 'Required',
        evolutivelabsEmail: (v: string) => validateCompanyEmail(v) || 'Incorrect email.'
      }
    }
  },

  watch: {
    email() {
      const form = this.$refs.form as VForm
      this.emailValid = form && form.validate()
    }
  },

  created() {
    this.email = (this.$route.query.resend as string | null) || ''

    if (this.email) {
      this.dialog = true
    }
  },

  methods: {
    async send() {
      if (this.processing) return false
      const form = this.$refs.form as VForm
      try {
        this.processing = true
        await auth.resendVerifyEmail(this.email)
        this.sended = true
        form.reset()
      } catch (e) {
        if ((e as AxiosError).response?.status === 404) {
          this.error = 'Email doest not exist.'
        } else if ((e as AxiosError).response?.status === 401) {
          this.error = (e as AxiosError).response?.data.message
        } else {
          window.console.error((e as AxiosError).response)
          this.error = 'Oops! Something went wrong, please contact IT team.'
        }
        window.setTimeout(() => (this.error = ''), 5000)
      } finally {
        this.processing = false
      }
    }
  },

  render(): VNode {
    const activator = (props: any) => (
      <v-btn text small on={props.on}>
        Not get verify email?
      </v-btn>
    )

    const errorAlert = (
      <v-alert outlined type="error">
        {this.error}
      </v-alert>
    )

    const successAlert = (
      <v-alert outlined type="success">
        Rhitics will send verify email to you, Please move to <a href="https://gmail.com">Gmail</a>.
      </v-alert>
    )

    const form = (
      <v-form ref="form" on={{ submit: this.send }}>
        <v-text-field rules={Object.values(this.rules)} v-model={this.email} label="Email" type="email" />
        <v-row>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            type="submit"
            on={{ click: this.send }}
            disabled={!this.emailValid || this.processing || !!this.error}
            loading={this.processing}
          >
            Submit
          </v-btn>
        </v-row>
      </v-form>
    )

    return (
      <v-dialog v-model={this.dialog} width="500" scopedSlots={{ activator }}>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Resend Verify Email
          </v-card-title>
          <v-card-text>
            {form}
            {this.sended ? successAlert : null}
            {this.error ? errorAlert : null}
          </v-card-text>
        </v-card>
      </v-dialog>
    )
  }
})
